import React, { useState } from 'react';

interface AmountButtonProps {
  amount: number;
  onClick: (amount: number) => void;
  selected?: boolean;
  accentColor?: string;
}

const AmountButton: React.FC<AmountButtonProps> = ({ amount, onClick, selected, accentColor = '#2563eb' }) => {
  const [pressed, setPressed] = useState(false);

  return (
    <button
      type="button"
      onPointerDown={() => setPressed(true)}
      onPointerUp={() => { setPressed(false); onClick(amount); }}
      onPointerLeave={() => setPressed(false)}
      className="flex flex-col items-center justify-center py-4 px-2 rounded-2xl border-2 font-bold text-lg transition-all duration-150"
      style={{
        background: selected || pressed ? accentColor : '#f8fafc',
        borderColor: selected || pressed ? accentColor : '#e2e8f0',
        color: selected || pressed ? '#fff' : '#1e293b',
        transform: pressed ? 'scale(0.94)' : 'scale(1)',
        boxShadow: (selected || pressed) ? `0 4px 16px ${accentColor}44` : '0 1px 4px rgba(0,0,0,0.06)',
      }}
    >
      <span className="text-xs font-semibold opacity-75 mb-0.5">RD$</span>
      {amount}
    </button>
  );
};

export default AmountButton;
